import { PathToValue } from '../types/pathToValue';

import { unwrapProxy } from './unwrapProxy';

export const getPathProperty = <T extends Record<string, unknown>, P extends string>(
   obj: T,
   path: P
): PathToValue<T, P> | undefined => {
   return unwrapProxy(obj[path]) as PathToValue<T, P> | undefined;
};
